module.exports = __webpack_public_path__ + "img/login_title.d382f3f5.png";